import type { Template } from '@commons/components/RichText/templates';
import ShareLinks, { type ShareLinkType } from '@commons/components/ShareLinks';
import PageBuilder from '@commons/pagebuilder';

/**
 * ShareLinks CKEditor template.
 *
 * @returns A rendered React component.
 */

const ShareLinksTemplate: Template = () => {
  const links: ShareLinkType[] = ['facebook', 'x', 'linkedin', 'email', 'pagelink'];

  const page = PageBuilder.getPage();
  const emailSubject = page?.metaTags.title;
  const emailBody = page?.metaTags?.description;

  return <ShareLinks links={links} emailSubject={emailSubject} emailBody={emailBody} />;
};

export default ShareLinksTemplate;
